import * as React from "react";

interface ComposerAttachmentChipRowProps {
  children: React.ReactNode;
}

/**
 * Shared horizontal scroll surface for composer attachment chips.
 *
 * Chip collections rendered inside this row must not create their own overflow
 * containers; files and task output should move together as one attachment row.
 */
export const ComposerAttachmentChipRow: React.FC<ComposerAttachmentChipRowProps> = ({
  children,
}) => (
  <div
    role="group"
    aria-label="Composer attachments"
    className="flex min-w-0 flex-nowrap items-start gap-2 overflow-x-auto scrollbar-none empty:hidden"
  >
    {children}
  </div>
);
